module.exports = __webpack_public_path__ + "media/images/icons/icons_small/1_flower-e2487ec8a003314b76f0a17300d8a890.png";